import React, {useEffect} from 'react';
import './App.css'
import WhoWeAreFeatured from './components/who/whoweare-featured'
import WhoWeAreBelieve from './components/who/whoweare-believe'
import WhoWeAreCulture from './components/who/whoweare-culture'
import WhoWeAreExpertise from './components/who/whoweare-expertise'
import AOS from "aos";
import "aos/dist/aos.css";

function WhoWeAre() {
  useEffect(() => {
    AOS.init({duration: 1000});
    window.scrollTo(0, 0);
  }, []);
  return (
   <>
   <WhoWeAreFeatured />
   <div data-aos="fade-up"><WhoWeAreBelieve /></div>
   <div data-aos="fade-up"><WhoWeAreCulture /></div>
   <div data-aos="fade-up"><WhoWeAreExpertise /></div>
   </>
  );
};

export default WhoWeAre;
